export class ChannelNotSupportedYetError extends Error {}
